import React from "react";
import { useEffect } from "react";
import Slider from "react-slick";
import AOS from "aos";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  FaArrowLeft,
  FaArrowRight,
  FaDownload,
  FaStar,
  FaWhatsapp,
  FaPhoneAlt,
} from "react-icons/fa";

const SuggestionComponent = ({ suggestions }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <div className="p-6 rounded-lg bg-indigo-50">
      <h2 className="text-2xl font-semibold text-indigo-500 mb-4">
        Related Products
      </h2>
      <Slider {...settings}>
        {suggestions?.map((pkg) => (
          <SuggestionCard key={pkg?.id} packageData={pkg} />
        ))}
      </Slider>
    </div>
  );
};

export const SuggestionCard = ({ packageData }) => {
  const {
    title,
    duration,
    price,
    originalPrice,
    discount,
    rating,
    reviews,
    image,
  } = packageData;

  return (
    <div className="bg-white cursor-pointer rounded-lg shadow-lg overflow-hidden mx-2 transition-transform transform hover:scale-105">
      <div className="relative">
        <img src={image} alt={title} className="w-full h-40 object-cover" />
        <div className="absolute top-2 left-2 bg-indigo-500 text-white text-xs px-2 py-1 rounded">
          BEST DEAL
        </div>
      </div>
      <div className="p-4">
        <p className="text-indigo-500 text-xs mb-1">{duration}</p>
        <h3 className="text-sm font-bold text-gray-800 mb-2">{title}</h3>
        <div className="flex items-center mb-2">
          <span className="text-indigo-600 font-semibold">{`⭐ ${rating}`}</span>
          <span className="text-gray-500 text-xs ml-2">{`(${reviews})`}</span>
        </div>
        <div className="text-sm font-bold text-gray-800 mb-1">{price}</div>
        <div className="text-xs text-gray-400 line-through">
          {originalPrice}
        </div>
        <div className="text-xs text-indigo-600">{discount}</div>
        <div className="mt-4 flex justify-between items-center">
          <button className="bg-indigo-500 text-white px-3 py-1 rounded-md text-xs hover:bg-indigo-600">
            Avail Offer
          </button>
          <button className="border border-[#5b53fb] text-[#5b53fb] px-2 py-1 rounded-md text-xs flex items-center hover:bg-blue-100 transition-transform transform hover:scale-105">
            <FaPhoneAlt className="mr-1" /> Contact
          </button>
        </div>
      </div>
    </div>
  );
};

export const SuggestionCardForBestPlaces = ({ packageData }) => {
  useEffect(() => {
    AOS.init({ duration: 500 });
  }, []);

  const {
    title,
    duration,
    price,
    originalPrice,
    discount,
    rating,
    reviews,
    images, // Adjusted to accept multiple images
  } = packageData;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };

  const handleDownload = () => {
    // Logic to handle PDF download
    // This can be a fetch request to download the PDF or redirect to a PDF URL
    window.location.href = "/path/to/your/itinerary.pdf"; // Replace with actual URL
  };

  const handleWhatsappClick = () => {
    window.open(`https://wa.me/917742386069`, "_blank");
  };

  return (
    <div
      className="bg-gradient-to-r from-white to-blue-50 cursor-pointer rounded-lg shadow-lg overflow-hidden mx-2 transition-transform transform hover:scale-105 hover:shadow-xl group"
      data-aos="fade-up"
      data-aos-delay={packageData.id * 100} // Delay based on the card's ID
    >
      <div className="relative">
        <Slider
          {...settings}
          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none group-hover:pointer-events-auto"
        >
          {images?.map((image, index) => (
            <div key={index}>
              <img
                src={image}
                alt={title}
                className="w-full h-40 object-cover"
              />
            </div>
          ))}
        </Slider>
        <img
          src={images[0]}
          alt={title}
          className="w-full h-40 object-cover group-hover:opacity-0 transition-opacity duration-300"
        />
        <div className="absolute top-2 left-2 bg-indigo-500 text-white text-xs px-2 py-1 rounded-lg shadow-md">
          BEST DEAL
        </div>
      </div>
      <div className="p-4">
        <p className="text-indigo-500 font-semibold text-xs mb-1">{duration}</p>
        <h3 className="text-lg font-bold text-gray-800 mb-2">{title}</h3>
        <div className="flex items-center mb-2">
          <span className="text-indigo-600 font-semibold flex items-center">
            <FaStar className="mr-1" /> {rating}
          </span>
          <span className="text-gray-500 text-xs ml-2">{`(${reviews})`}</span>
        </div>
        <div className="text-lg font-bold text-gray-800 mb-1">{price}</div>
        <div className="text-xs text-gray-500 line-through">
          {originalPrice}
        </div>
        <div className="text-sm flex justify-between text-indigo-500 font-semibold">
          {discount}{" "}
          <button
            onClick={handleDownload}
            className="bg-indigo-500 text-white px-2 py-1 rounded-md text-xs flex items-center hover:bg-indigo-600 transition-transform transform hover:scale-105"
          >
            <FaDownload className="mr-1" /> Download PDF
          </button>
        </div>
        <div className="mt-4 flex justify-between items-center">
          <button className="bg-gradient-to-r from-indigo-500 to-indigo-800 text-white px-3 py-1 rounded-md text-xs hover:from-indigo-400 hover:to-indigo-800 transition-transform transform hover:scale-105">
            Avail Offer
          </button>
          <button className="border border-[#5b53fb] text-[#5b53fb] px-2 py-1 rounded-md text-xs flex items-center hover:bg-blue-100 transition-transform transform hover:scale-105">
            <FaPhoneAlt className="mr-1" /> Contact
          </button>
          <button
            onClick={handleWhatsappClick}
            className="text-white bg-green-500 p-2 rounded-full text-xs flex items-center justify-center transition-transform transform group-hover:animate-bounce"
          >
            <FaWhatsapp className="text-2xl" />
          </button>
        </div>
      </div>
    </div>
  );
};

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} hover:text-teal-800 text-teal-600`}
      style={{ ...style, display: "block", fontSize: "20px" }}
      onClick={onClick}
    >
      <FaArrowRight />
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} hover:text-teal-800 text-teal-600`}
      style={{ ...style, display: "block", fontSize: "20px" }}
      onClick={onClick}
    >
      <FaArrowLeft />
    </div>
  );
};

export default SuggestionComponent;
